import { Info } from "lucide-react";

/**
 * Bandeau d'information affiché sur les écrans d'écriture économe quand l'année
 * scolaire sélectionnée n'est PAS l'année active. Les écritures sont alors
 * inhibées côté front (et refusées en 400 côté back) — la lecture reste libre.
 */
export default function AnneeInactiveBanner() {
  return (
    <div
      data-testid="annee-inactive-banner"
      className="mb-4 flex items-start gap-2 rounded-lg border border-amber-200 bg-amber-50 px-3 py-2 text-sm text-amber-800"
    >
      <Info className="mt-0.5 h-4 w-4 shrink-0" />
      <span>Année non active. Sélectionnez l'année en cours pour modifier.</span>
    </div>
  );
}
